<app-tooltip [dynamic]="false"  class="display-inline-flex" [message]="setTooltipText()">
    <span [class]="setCssClass()"></span>
</app-tooltip>
